import i18next from "i18next";
import { FieldType, ThirdpartyScoresFieldsNames } from "./Constants";
import { theme } from "style/globalStyle";


export const DATABLOCKS_SUBSCRIPTIONS = {
  FINANCIALSTRENGTH : "financialStrength", 
  ESG: 'ESG'
}


export const FINANCIAL_STRENGTH_SCORES = {
    VERY_LOW: 'VERY_LOW', 
    LOW: 'LOW', 
    MEDIUM: 'MEDIUM', 
    HIGH: "HIGH", 
    VERY_HIGH: "VERY_HIGH"
}

export const FINANCIAL_STRENGTH_SCORES_VALUE = Object.freeze({
    UNKNOWN: "-",
    VERY_LOW: "1",
    LOW: "2",
    MEDIUM: "3",
    HIGH: "4",
    VERY_HIGH: "0", 
    NO_EVALUATED: "-1"
});

export const getFinancialStrengthScoreValuesForRulesAndCalculations = () => {
  return [
    { value: "UNKNOWN", label: i18next.t(`datablocks.financialStrength.severity.unknown`)},
    {value: "VERY_LOW", label: i18next.t(`datablocks.financialStrength.severity.${FINANCIAL_STRENGTH_SCORES.VERY_LOW.toLowerCase()}`)},
    { value: "LOW", label: i18next.t(`datablocks.financialStrength.severity.${FINANCIAL_STRENGTH_SCORES.LOW.toLowerCase()}`)},
    {value: "MEDIUM", label: i18next.t(`datablocks.financialStrength.severity.${FINANCIAL_STRENGTH_SCORES.MEDIUM.toLowerCase()}`)},
    { value: "HIGH", label: i18next.t(`datablocks.financialStrength.severity.${FINANCIAL_STRENGTH_SCORES.HIGH.toLowerCase()}`)},
  ];
}

export const getFinancialStrengthScoreColorAndLabel = (score) => {
  const scoreString = score?.toString();
  if(scoreString === "0") {
    return {color : theme.palette.error.error700, text: i18next.t("financialStrength.riskVeryHigh")}
  } else if(scoreString === "4") {
    return {color : theme.palette.error.error600, text: i18next.t("financialStrength.riskHigh")}
  } else if(scoreString === "3") {
    return {color : theme.palette.warning.warning500, text: i18next.t("financialStrength.riskMedium")}
  } else if(scoreString === "2") {
    return {color : theme.palette.primary.main, text: i18next.t("financialStrength.riskLow")}
  } else if(scoreString === "1") {
    return {color : theme.palette.primary.primary400, text: i18next.t("financialStrength.riskVeryLow")}
  } else {
    return {color : theme.palette.grey.grey300, text: i18next.t("financialStrength.riskUnknown")}
  }
}

export const getEsgScores = () => {
  return [
    { label: i18next.t("ESG.score"+1+"label"), value : 1},
    { label: i18next.t("ESG.score"+2+"label"), value : 2},
    { label: i18next.t("ESG.score"+3+"label"), value : 3},
    { label: i18next.t("ESG.score"+4+"label"), value : 4},
    { label: i18next.t("ESG.score"+5+"label"), value : 5},
    { label: i18next.t("ESG.scoreUnknownLabel"), value : 0},
    { label: i18next.t("ESG.noEsgScoring"), value : -1},
  ];
}

export const ESG_SCORES_STRING_VALUES = getEsgScores().map(item => { return {...item, value: item.value.toString()}});

export const getEsgScoresForRulesAndCalculations = () => {
  return getEsgScores().map(item => { return {...item, value: item.value.toString()}})
                                                .filter(item => item?.value !== "0" && item?.value !== "-1");
}

export const getEsgDepths = () => {
  return [
    { value: 'A', label: 'A', description: i18next.t('ESG.depthA'), shortDescription: i18next.t('ESG.depthAshort') },
    { value: 'B', label: 'B', description: i18next.t('ESG.depthB'), shortDescription: i18next.t('ESG.depthBshort') },
    { value: 'C', label: 'C', description: i18next.t('ESG.depthC'), shortDescription: i18next.t('ESG.depthCshort') },
    { value: 'D', label: 'D', description: i18next.t('ESG.depthD'), shortDescription: i18next.t('ESG.depthDshort') },
    { value: 'E', label: 'E', description: i18next.t('ESG.depthE'), shortDescription: i18next.t('ESG.depthEshort') },
    { value: 'F', label: 'F', description: i18next.t('ESG.depthF'), shortDescription: i18next.t('ESG.depthFshort') },
    { value: 'G', label: 'G', description: i18next.t('ESG.depthG'), shortDescription: i18next.t('ESG.depthGshort') },
    { value: 'H', label: 'H', description: i18next.t('ESG.depthH'), shortDescription: i18next.t('ESG.depthHshort') },
    { value: 'I', label: 'I', description: i18next.t('ESG.depthI'), shortDescription: i18next.t('ESG.depthIshort') },
  ]
}

export const ESG_SCORES_THEMES = [
  {value: "1", label: "1"},
  {value: "2", label: "2"},
  {value: "3", label: "3"}
]

export const generateEsgScoresTopics = () => {
  const arrayScores = []
  for(let i = 1; i <=100; i++) {
    arrayScores.push({value: `${i}`, label: `${i}`})
  }
  return arrayScores;
}

export const getEsgScoresColor = (score) => {
  if(score === 5 || score === '5') {
      return theme.palette.error.error600;
  } else if( score === 4 || score === '4' ) {
      return theme.palette.warning.warning600;
  } else if (score === 3 || score === '3') {
      return theme.palette.warning.warning500;
  } else if (score === 2 || score === '2' ) {
      return theme.palette.primary.primary400;
  } else if (score === 1 || score === '1' ) {
      return "#2D9F40"
  } else {
      return theme.palette.grey.grey400;
  }
}

export const getEsgScopesFields = () => {
  return [
    {
      value: ThirdpartyScoresFieldsNames.ESG_SCORE,
      label: i18next.t('ESG.field.esg_score'),
      type: FieldType.RISK,
      subType: 'ESG',
      valueOptions: ESG_SCORES_STRING_VALUES,
    },
    {
      value: ThirdpartyScoresFieldsNames.ESG_RISK_ENVIRONMENTAL,
      label: i18next.t('ESG.riskEnvironment'),
      type: FieldType.RISK,
      subType: 'ESG',
      valueOptions: ESG_SCORES_STRING_VALUES,
    },
    {
      value: ThirdpartyScoresFieldsNames.ESG_RISK_SOCIAL,
      label: i18next.t('ESG.riskSocial'),
      type: FieldType.RISK,
      subType: 'ESG',
      valueOptions: ESG_SCORES_STRING_VALUES,
    },
    {
      value: ThirdpartyScoresFieldsNames.ESG_RISK_GOVERNANCE,
      label: i18next.t('ESG.riskGovernance'),
      type: FieldType.RISK,
      subType: 'ESG',
      valueOptions: ESG_SCORES_STRING_VALUES,
    },
  ];
}


export const formatEsgScoresAsIndicators = (esgData) => {
  const id = "esg";
  let name = i18next.t("ESG.scoreGlobalLabel");
  let resultValue = "";
  let resultColorCode = "";
  let resultLastUpdateDate = undefined;
  let subScores = undefined;

  if(isNoEsgScoring(esgData)) {
    resultValue = i18next.t("ESG.noEsgScoring");
    resultColorCode = theme.palette.grey.grey200;
  } else if(esgData?.noDataAvailable) {
    resultValue = i18next.t("ESG.scoreUnknownLabel");
    resultColorCode = theme.palette.grey.grey400;
  } else {
    resultValue = i18next.t("ESG.score"+esgData.score+"label");
    resultColorCode = getEsgScoresColor(esgData.score);
    resultLastUpdateDate = esgData.scoreDate;
    subScores = [
      {
        id: "riskEnvironmental",
        name: i18next.t("ESG.labelEnvironment"),
        resultColorCode: getEsgScoresColor(esgData.environmentalRankingScore),
        resultValue: getEsgScores().find(score => score.value === esgData.environmentalRankingScore)?.label  || getEsgScores().find(score => score.value === 0)?.label
      }, 
      {
        id: "riskSocial",
        name: i18next.t("ESG.labelSocial"),
        resultColorCode: getEsgScoresColor(esgData.socialRankingScore),
        resultValue: getEsgScores().find(score => score.value === esgData.socialRankingScore)?.label || getEsgScores().find(score => score.value === 0)?.label
      },
      {
        id: "riskGovernance",
        name: i18next.t("ESG.labelGovernance"),
        resultColorCode: getEsgScoresColor(esgData.governanceRankingScore),
        resultValue: getEsgScores().find(score => score.value === esgData.governanceRankingScore)?.label || getEsgScores().find(score => score.value === 0)?.label
      }
    ]
  }
  return {
    id: id,
    name: name, 
    resultValue: resultValue, 
    resultColorCode: resultColorCode, 
    resultLastUpdateDate: resultLastUpdateDate, 
    subScores: subScores
  }
}


export const isNoEsgScoring = (esg) => {
    return !esg?.score && !esg?.noDataAvailable
}